/**
 * /login — G7 §47, §51 e §59.
 *
 * O Supabase Auth é a autoridade. Não há tabela de login paralela, não há hash
 * de senha neste repositório e não há "usuário administrador" com atalho.
 *
 * A SENHA NÃO PASSA POR AQUI
 *
 *   O campo é `type="password"`, o valor vai direto para
 *   `signInWithPassword` e nunca é guardado em estado global, log, telemetria
 *   ou `localStorage`. O que sobra depois do login é a sessão emitida pelo
 *   provedor — um token com prazo, não a credencial.
 *
 * A MENSAGEM DE ERRO É A DELES
 *
 *   A documentação oficial avisa que o provedor não distingue "conta não
 *   existe" de "senha errada", de propósito: distinguir permitiria enumerar
 *   contas. Reescrever a mensagem para algo mais "útil" desfaria essa proteção
 *   ou inventaria uma informação que ninguém tem.
 */

import { useState, type FormEvent } from 'react';
import { useSession } from '../lib/session.js';

export function LoginPage() {
  const { signIn, state } = useSession();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function onSubmit(evento: FormEvent) {
    evento.preventDefault();
    setEnviando(true);
    setErro(null);
    const { error } = await signIn(email, senha);
    setEnviando(false);
    if (error !== null) setErro(error);
    // Sucesso não navega aqui: quem observa a sessão é o roteador. Redirecionar
    // daqui criaria uma segunda fonte de verdade sobre "estou autenticado".
  }

  return (
    <main className="of-login">
      <form className="of-login__card" onSubmit={onSubmit}>
        <img
          className="of-login__logo"
          src="/optefiscal-logo-oficial.svg"
          alt="OpteFiscal"
          width={220}
          height={48}
        />

        <h1 className="of-login__title">Console Fiscal</h1>
        <p className="of-login__subtitle">
          Infraestrutura fiscal da Opte Sistemas. Acesso restrito a identidades autorizadas.
        </p>

        <label className="of-field">
          <span className="of-field__label">E-mail</span>
          <input
            className="of-field__input"
            type="email"
            name="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={enviando}
          />
        </label>

        <label className="of-field">
          <span className="of-field__label">Senha</span>
          <input
            className="of-field__input"
            type="password"
            name="password"
            autoComplete="current-password"
            required
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            disabled={enviando}
          />
        </label>

        {erro !== null && (
          <div className="of-login__error" role="alert">
            {erro}
          </div>
        )}

        <button className="of-button of-button--primary" type="submit" disabled={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>

        {state === 'error' && (
          <p className="of-login__note">
            A sessão foi criada, mas a consulta de acesso fiscal falhou. Isto não é senha errada.
          </p>
        )}
      </form>
    </main>
  );
}
